import { render, staticRenderFns } from "./MisWaybills.vue?vue&type=template&id=63fa04ca&"
import script from "./MisWaybills.vue?vue&type=script&lang=js&"
export * from "./MisWaybills.vue?vue&type=script&lang=js&"
import style0 from "./MisWaybills.vue?vue&type=style&index=0&id=63fa04ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports